import React from 'react';
import './TimerTabs.css';

const TimerTabs: React.FC = () => {
  return <></>;
};

export default TimerTabs;
